
<div  class="card">
    <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems" [listService]="notificationListService"
    [sortBy]="sortBy" (buttonActionSelected)="buttonActionSelected($event)"  (updateCheckedValues)="checkedValGet =  $event"
    (rowActionSelected)="rowActionSelected($event)" (filterSelected)="filterSelected($event)"
    (sortSelected)="sortByPassedSort($event)" 
    (resetListLayout) = "notificationListService.resetListState($event)"
    (searchTermChanged)="notificationListService.searchTerm = $event"
    (paginationSelected)="paginationUpdated(notificationListService,$event)" [serviceData]="serviceData"
    (pageSizeSelected) = "notificationListService.pageSize = $event"
    ></app-list-layout>
</div> 
<!--
<div id="clientList" class="card">
    <div class="card-header border-0">
        <div class=" d-grid d-sm-flex align-items-center">
            <h5 class="flex-grow-1 fs-17 " style="padding-top: 0.5%;" i18n="@@">Notification List</h5>
        </div>
    </div>
    <div class="card-header card-body bg-soft-light border border-dashed border-start-0 border-end-0">
        <div class="row g-3">
            <div class="col-md-4">
                <div class="d-flex align-items-center gap-2 ">
                    <div class="search-box flex-grow-1">
                        <input type="text" name="searchTerm" class="form-control search bg-light border-light"
                            placeholder="Search by file name" [(ngModel)]="notificationListService.searchTerm">
                        <i class="ri-search-line search-icon"></i>
                        <i class="mdi mdi-close-circle search-widget-icon search-widget-icon-close"
                            *ngIf="notificationListService.searchTerm && notificationListService.searchTerm.length >0"
                            style="font-size: 1rem;
                                    position: absolute;
                                    cursor: pointer;
                                    right: 13px;
                                    top: 0;
                                    height: 100%;
                                    display: flex;
                                    align-items: center;
                                    color: #878a99;" (click)="clearSearch(notificationListService)"></i>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-ng-select-layout-filter [placeHolderText]="'Select Status'" (statusChanged)="isReadFilter($event)" [items]="enumIsReadValueType" ></app-ng-select-layout-filter>
            </div>

            <div class="col-md-3">
                <app-ng-select-layout-filter [placeHolderText]="'Select Types'" (statusChanged)="notificationTypeFilter($event)" [items]="enumNotificationValueType" ></app-ng-select-layout-filter>
            </div>

            <div class="col-md-auto ms-auto">
                <div class="d-flex align-items-center gap-2">
                    <div ngbDropdown>
                        <button type="button" id="dropdownMenuLink1" data-bs-toggle="dropdown" aria-expanded="false"
                            class="btn btn-soft-secondary arrow-none" ngbDropdownToggle>
                            <i class="ri-more-2-fill"></i>
                        </button>
                        <ul class="dropdown-menu " ngbDropdownMenu style=" position: absolute; ">
                            <li>
                                <a class="dropdown-item" href="javascript:void(0);" style="cursor:pointer"
                                    (click)=changeReadStatusMultiple()><i
                                        class="ri-chat-check-line align-bottom me-2 text-muted"></i>
                                    <span i18n="@@"> Mark As Read </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card-body p-0">

        <div
            style="padding-right: 1rem; padding-left: 1rem; overflow: scroll; margin-bottom: 0; scrollbar-width: none; ">
            <div class="table-responsive table-card " style="margin-bottom: 0; margin-top: 0; overflow-y: hidden; ">
                <table class="table align-middle table-nowrap" style="margin-bottom: 0;">

                    <thead class="text-muted table-light">
                        <tr>

                            <th scope="col" style="width: 50px;">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="checkAllNotifications"
                                        value="option" style="cursor:pointer" [(ngModel)]="masterSelected"
                                        (change)="checkUncheckAll($event,listItems)">
                                </div>
                            </th>

                            <th scope="col" style="width:50%">
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Subject</span>
                                </div>
                            </th>

                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Modified Date</span>

                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Status</span>

                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Actions</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="list form-check-all">

                        <tr *ngFor="let data of listItems ; index as i" id="i_{{data.id}}">


                            <td scope="row">
                                <div class="form-check">
                                    <input id="checkboxId" class="form-check-input" type="checkbox"
                                        name="checkAllNotifications" style="cursor:pointer"
                                        (click)="stopPropagationOnClick($event)" value="{{data.id}}"
                                        (change)="onCheckboxChange($event, listItems)" [(ngModel)]="data.state">
                                </div>
                            </td>

                            <td>
                                <ngb-highlight style="cursor:pointer" [result]="data.subject"
                                    (click)="openNotificationModal(data)" [term]="notificationListService.searchTerm">
                                </ngb-highlight>
                            </td>

                            <td>
                                <ngb-highlight style="cursor:default" [result]="dateRename(data.modifiedDate)"
                                    [term]="notificationListService.searchTerm">
                                </ngb-highlight>
                            </td>
                            <td>
                                <div *ngIf="data.isRead == false">
                                    <span class="rounded coloredTextArea blue">
                                        Unread
                                    </span>
                                </div>
                                <div *ngIf="data.isRead == true">
                                    <span class="rounded coloredTextArea purple">
                                        Read
                                    </span>
                                </div>
                            </td>

                            <td>
                                <div class=" d-flex ">
                                    <ul class="list-inline hstack gap-2 mb-0">
                                        <li class="list-inline-item">
                                            <div class="dropdown" ngbDropdown style="z-index: 100;  position: static;">
                                                <button class="btn btn-soft-secondary btn-sm dropdown arrow-none"
                                                    type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                                    ngbDropdownToggle>
                                                    <i class="ri-more-fill align-middle"></i>
                                                </button>

                                                <ul class="dropdown-menu " ngbDropdownMenu
                                                    style=" position: absolute; ">
                                                    <li *ngIf="data.isRead === false"> <button [disabled]="submitted"
                                                            class="dropdown-item edit-item-btn" style="cursor:pointer"
                                                            (click)="changeReadStatus(data.id)" data-bs-toggle="modal">
                                                            <span>
                                                                <i
                                                                    class="ri-chat-check-line align-bottom me-2 text-muted"></i>
                                                                Mark as Read
                                                            </span>
                                                        </button>
                                                    </li>
                                                    <li> <button [disabled]="submitted"
                                                            class="dropdown-item edit-item-btn" style="cursor:pointer"
                                                            (click)="openNotificationModal(data)"
                                                            data-bs-toggle="modal">
                                                            <span>
                                                                <i class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                                View
                                                            </span>
                                                        </button>
                                                    </li>
                                                    <li> <button [disabled]="submitted"
                                                            class="dropdown-item edit-item-btn" style="cursor:pointer"
                                                            (click)="delete(data.id)" data-bs-toggle="modal">
                                                            <span>
                                                                <i class="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                                                                Delete
                                                            </span>
                                                        </button>
                                                    </li>
                                                </ul>

                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>

            </div>
        </div>
    </div>

    <div class=" card-body ">
        <div class="row justify-content-md-between align-items-md-center">
            <div class="col col-sm-6">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                    {{pagingInfo(notificationListService)}}
                </div>
            </div>
            <div class="col col-sm-6">
                <div class="text-sm-right float-end listjs-pagination">
                    <ngb-pagination [collectionSize]="(total | async)!" [(page)]="notificationListService.startIndex">
                        <ng-template ngbPaginationPages let-page let-pages="pages">
                            <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                                <div class="mb-3 d-flex flex-nowrap px-2">
                                    <label id="paginationInputLabel" for="paginationInput"
                                        class="col-form-label me-2 ms-1" i18n="@@Pagination_Text_Page">Page</label>
                                    <input #i type="text" inputmode="numeric" pattern="[0-9]*"
                                        class="form-control custom-pages-input" id="paginationInput"
                                        [value]="notificationListService.startIndex"
                                        (keyup.enter)="selectPage(notificationListService,i.value)"
                                        (blur)="selectPage(notificationListService,i.value)"
                                        (input)="formatPageInput($any($event).target)"
                                        aria-labelledby="paginationInputLabel paginationDescription"
                                        style="text-align: center; width:3.5rem;" />
                                    <span id="paginationDescription" class="col-form-label text-nowrap px-2 ">
                                        <span i18n="@@Pagination_Text_Of">of</span> {{pages.length}}</span>
                                </div>
                            </li>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isLoadingVal" id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>

</div> -->